// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixLocation from 'wix-location';
import { sendComplaintToDistrict } from 'backend/complaint';
import moment from 'moment';
import { local } from 'wix-storage';

let robot = true;

$w.onReady(function () {
    $w('#captcha').onVerified(() => {
        robot = false;
    });
});

export function sendFinishedCase_click(event) {
    $w('#loader').expand();

    let rulesCheck = $w('#rulesCheck').checked;

    if (robot) {
        $w('#error').text = 'Трябва да потвърдите, че не сте робот!';
        $w('#error').expand();
        $w('#loader').collapse();
        return;
    }

    if (!rulesCheck) {
        $w('#error').text = 'Трябва да се съгласите с общите условия, за да продължите!';
        $w('#error').expand();
        $w('#loader').collapse();
        return;
    }

    if (!$w('#error').collapsed) {
        $w('#error').collapse();
        $w('#error').text = 'Моля, попълнете полетата в червено, за да продължите!';
    }

    let data = {
        toCity: $w('#toCity'),
        nameFrom: $w('#nameFrom'),
        egnFrom: $w('#egnFrom'),
        cityFrom: $w('#cityFrom'),
        regionFrom: $w('#regionFrom'),
        municipalityFrom: $w('#municipalityFrom'),
        addressFrom: $w('#addressFrom'),
        blockFrom: $w('#blockFrom'),
        entranceFrom: $w('#entranceFrom'),
        floorFrom: $w('#floorFrom'),
        telephoneFrom: $w('#telephoneFrom'),
        nameAgainst: $w('#nameAgainst'),
        egnAgainst: $w('#egnAgainst'),
        cityAgainst: $w('#cityAgainst'),
        regionAgainst: $w('#regionAgainst'),
        municipalityAgainst: $w('#municipalityAgainst'),
        addressAgainst: $w('#addressAgainst'),
        blockAgainst: $w('#blockAgainst'),
        entranceAgainst: $w('#entranceAgainst'),
        floorAgainst: $w('#floorAgainst'),
        facts: $w('#facts'),
        application1: $w('#application1'),
        application2: $w('#application2'),
        application3: $w('#application3'),
        application4: $w('#application4'),
        dateToSign: $w('#dateToSign'),
        cityToSign: $w('#cityToSign'),
    }

    Object.entries(data).map(item => {
        if (!item[1].value) {
            item[1].updateValidityIndication();
            if (!item[1].valid) {
                if ($w('#error').collapsed) {
                    $w('#error').expand();
                    $w('#loader').collapse();
                }
            }
        }
    });

    if (!$w('#error').collapsed) {
        return;
    }

    const momentDate = moment(data.dateToSign.value);
    let formatedDate = momentDate.format("YYYY-MM-DD HH:MM:SS");

    sendComplaintToDistrict(data.toCity.value, data.nameFrom.value, data.egnFrom.value, data.cityFrom.value, data.regionFrom.value, data.municipalityFrom.value, data.addressFrom.value,
            data.blockFrom.value, data.entranceFrom.value, data.floorFrom.value, data.telephoneFrom.value, data.nameAgainst.value, data.egnAgainst.value, data.cityAgainst.value,
            data.regionAgainst.value, data.municipalityAgainst.value, data.addressAgainst.value, data.blockAgainst.value, data.entranceAgainst.value, data.floorAgainst.value,
            data.facts.value, data.application1.value, data.application2.value, data.application3.value, data.application4.value, formatedDate, data.cityToSign.value)
        .then(response => {
            console.log(response);
            $w('#loader').collapse();
            if (response.error) {
                throw new Error(response.error.message);
            }
            local.setItem('filePath', response.filePath);
            local.setItem('fileName', response.fielName);
            local.setItem('complaint', 'district');

            wixLocation.to('/petition-success');
        }).catch(error => {
            $w('#loader').collapse();
            if (error.message === 'REQUIRED_FIELDS') {
                $w('#error').expand();
            }
        });

}